import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';
import { SubscriptionFacadeService } from '@app/forms/subscription/services/subscription-facade.service';

import { Validators } from '@angular/forms';
import { ProductDao } from '@app/dao/product/product.dao';
import { InfoOption } from '@app/forms/subscription/definition/interface/pledge-options';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';

@Component({
    selector: 'contigency-protect-loved',
    templateUrl: './contigency-protect-loved.component.html',
    styleUrls: ['./contigency-protect-loved.component.scss'],
    standalone: false
})
export class ContigencyProtectLovedComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  parameters;
  options: any[] = [];
  optionInfo1: InfoOption = {
    icon: 'warning',
    backgroundColor: '#fae4e4',
    iconColor: '#a00d0d',
    textColor: '#a00d0d',
  };

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
    protected productDao: ProductDao,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    const pledge = this.subscriptionFacade.getPledge();
    this.parameters = pledge?.parameters;
    this.subscriptionFacade.initForm(this, { ...this.parameters });

    this.productDao.getPrevoyanceProtectLovedRef().subscribe(data => {
      this.options = data.map(({ id, value }) => ({ label: value, value: id }));
    });

    this.products
      ?.get(`${0}`)
      ?.get('parameters')
      ?.get('protectLovedOnesInCaseOfAccidentOrDeath')
      ?.valueChanges.subscribe(value => {
        if (value) {
          this.products
            ?.get(`${0}`)
            ?.get('parameters')
            ?.get('protectLovedOnesInCaseOfAccidentOrDeathNeeds')
            ?.setValidators(Validators.required);
        } else {
          this.products
            ?.get(`${0}`)
            ?.get('parameters')
            ?.get('protectLovedOnesInCaseOfAccidentOrDeathNeeds')
            ?.clearValidators();
        }

        this.products
          ?.get(`${0}`)
          ?.get('parameters')
          ?.get('protectLovedOnesInCaseOfAccidentOrDeathNeeds')
          ?.updateValueAndValidity();
      });
  }

  onSubmit() {
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
